import { put, takeLatest, call, all } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';

// GET_WALLET_TRANSACTIONS
function* getHistoryReplenishment({ payload }) {
  try {
    const { data, status } = yield call(api.wallets.getReplenishedHistory, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_REPLENISHED_HISTORY_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_REPLENISHED_HISTORY_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* historyReplenishment() {
  yield takeLatest(types.GET_REPLENISHED_HISTORY_START, getHistoryReplenishment);
}
